export const goodVibesEn = {
    GoodVibeDetailRoute: {
        deleteSuccess: "Good Vibe deleted",
        deleteCommentSuccess: "Reply deleted",
        deleteError: "An error occurred while deleting the Good Vibe. Please try again.",
        deleteErrorForbidden: "You no longer have permission to delete this Good Vibe.",
        editSuccess: "Good Vibe updated",
        editError: "An error occurred while updating the Good Vibe. Please try again.",
        editErrorForbidden: "You no longer have permission to edit this Good Vibe.",
        editCommentSuccess: "Reply updated",
        addCommentError: "An error occurred while posting your reply. Please try again."
    }
};

export const goodVibeCardEn = {
    eyebrow: "Good Vibes",
    unknownSender: "Deleted member",
    from: "From {{name}}",
    fromUnknownSender: "From a deleted member",
    peopleCount_one: "{{count}} person",
    peopleCount_other: "{{count}} people",
    reactionCount_one: "{{count}}",
    reactionCount_other: "{{count}}",
    reactionMembersOverflow_one: "and {{count}} more",
    reactionMembersOverflow_other: "and {{count}} more",
    replyCount_one: "{{count}} reply",
    replyCount_other: "{{count}} replies",
    addReply: "Add reply",
    openDetailAriaLabel: "Open Good Vibe from {{sender}}",
    openDetailUnreadAriaLabel: "Open unread Good Vibe from {{sender}}",
    react: {
        button: "React",
        addReactionLabel: "Add {{glyph}} reaction",
        removeReactionLabel: "Remove {{glyph}} reaction"
    }
};

export const goodVibeDetailDialogEn = {
    heading: "Good Vibes from {{sender}}",
    unknownSender: "Deleted member",
    toLabel: "to",
    reactionCount_one: "{{count}}",
    reactionCount_other: "{{count}}",
    reactionMembersOverflow_one: "and {{count}} more",
    reactionMembersOverflow_other: "and {{count}} more",
    repliesLabel: "Replies",
    repliesSubtitle: {
        public: "Everyone in your organization can see replies",
        direct: "Recipients, their managers, and higher-ups can see replies"
    },
    visibility: {
        public: "Public",
        direct: "Direct",
        publicTooltip: "Everyone in your organization can see this.",
        directTooltip: "Recipients, their managers, and higher-ups can see this."
    },
    react: {
        button: "+ React",
        addReactionLabel: "Add {{glyph}} reaction",
        removeReactionLabel: "Remove {{glyph}} reaction"
    },
    delete: {
        button: "Delete",
        confirmTitle: "Delete this Good Vibe?",
        confirmDescription: "This removes what you wrote. Recipients will see only that it was deleted, and it cannot be undone.",
        confirmAction: "Delete",
        cancelAction: "Keep"
    },
    edit: {
        button: "Edit",
        dialogTitle: "Edit Good Vibe",
        messageLabel: "Message",
        messageCharactersLeft: "{{remaining}} characters left",
        subjectLabel: "Subject",
        audienceLabel: "Audience",
        publicLabel: "Public",
        publicDescription: "Everyone at the company can see this.",
        directLabel: "Direct",
        directDescription: "Only the recipients, their managers, and higher-ups can see this.",
        saveAction: "Save edits & send",
        cancelAction: "Cancel",
        fromLabel: "From {{sender}}",
        recipientsLabel: "To",
        removeRecipient: "Remove {{name}}",
        recipientSearchPlaceholder: "Add another",
        recipientSearchNoResults: "No results found",
        recipientSearchLoading: "Searching…",
        recipientSearchError: "Failed to load results",
        recipientSearchLoadedMore: "Loaded {{count}} more results",
        discardChangesTitle: "Discard your changes?",
        discardChangesBody: "Your changes have not been saved. Leaving now will lose what you have edited.",
        discardChangesConfirmLabel: "Discard",
        discardChangesCancelLabel: "Keep editing"
    },
    deleteComment: {
        button: "Delete",
        confirmQuestion: "Delete this reply?",
        confirmAction: "Delete",
        cancelAction: "Cancel"
    },
    editComment: {
        button: "Edit",
        label: "Edit your reply",
        saveAction: "Save",
        cancelAction: "Cancel"
    },
    reactToComment: {
        button: "+ React",
        addReactionLabel: "Add {{glyph}} reaction to reply",
        removeReactionLabel: "Remove {{glyph}} reaction from reply"
    },
    reply: {
        label: "Add a reply",
        placeholder: "Reply to keep the vibe going",
        submitButton: "Send",
        justNow: "Just now"
    },
    discardReply: {
        title: "Discard your reply?",
        confirmLabel: "Discard",
        cancelLabel: "Keep editing"
    }
};
